import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss']
})

export class ChangepasswordComponent {
  public loading:boolean = false;
  public submitted:boolean = false;
  selectedFile:any;
  public loginDetail:any =[];
  
  ResetData = new FormGroup({
    npassword:new FormControl('',Validators.compose([
      Validators.required,Validators.minLength(8),
      Validators.maxLength(30) ,
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}') 
    ])),
    password:new FormControl('',Validators.compose([
      Validators.required,Validators.minLength(8),
      Validators.maxLength(30) ,
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}') 
    ])),
    cpassword:new FormControl('',Validators.compose([
      Validators.required,Validators.minLength(8),
      Validators.maxLength(30) ,
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}')
    ])),
  })
  
   // convenience getter for easy access to form fields
   get f() { return this.ResetData.controls; }

   constructor(public router: Router, private service: GlobalService) {
    this.loginDetail = getLocalJSON('grw_login');
    }

   ngOnInit(): void {
   }

  Onsubmit(){
    this.loading=true;
    this.submitted = true;
    let userDetail = this.ResetData;
    if(userDetail.value.cpassword != userDetail.value.npassword){
      this.service.dangerAlert('Password not match');
      this.loading=false;
       return ;
    } else {
      if(userDetail.valid){ 
        this.loading = true;
        this.submitted = false; 
        let url="/change-password";
        let detail = 
        {
          "confirm_password": userDetail.value.cpassword,
          "old_password": userDetail.value.password ,
          "new_password": userDetail.value.npassword
        };
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1){
            this.service.successAlert(response.message);
            this.submitted = false;
            this.ResetData.reset();
            this.router.navigate(['/profile']);
            this.loading = false;
          } else {
            this.service.dangerAlert(response.message);
            this.loading = false;
          }
        }))
      } else{
        this.loading=false;
        window.scroll(0,0);
      }
    } 
  }

  showHide(str: any) {
    var input = $($(str).attr("toggle"));
    if (input.attr("type") == "password") {
      input.attr("type", "text");
      $(str).removeClass("fa-regular fa-eye-slash");
      $(str).addClass("fa-regular fa-eye ");
    } else {
      input.attr("type", "password");
      $(str).removeClass("fa-regular fa-eye ");
      $(str).addClass("fa-regular fa-eye-slash");
    }
  }
}
